import { render } from "./WeeklyTargetRule.vue?vue&type=template&id=628a79a3"
import script from "./WeeklyTargetRule.vue?vue&type=script&lang=js"
export * from "./WeeklyTargetRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__